import React, { useState, useRef, useEffect, useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import JsBarcode from 'jsbarcode';
import QRCode from "qrcode";
import './RENT_Rent_Roll_Snapshot.css';

const RENT_Rent_Roll_Snapshot = (props) => {
  const didFetchRef = useRef(false);
  const initRef = useRef({ headerHandled: false, dataTableHandled: false });

  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();

  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };


  const [newData, setNewData] = useState({
 	Source_Path:"RENT_RENT_ROLL_SNAPSHOT",
    Status: App_Data.Status,
    Parameter: App_Data.Parameter,
    Search: App_Data.Search,
    Return_Path: App_Data.Return_Path,
    Return_ID: App_Data.ID,
    Return_Status: App_Data.Return_Status,
	Object_Text:";",
	RENT_RENT_ROLL_SNAPSHOT:-1
  });


  const [RENT_RENT_ROLL_SNAPSHOT, setRENT_RENT_ROLL_SNAPSHOT] = React.useState(null);
  const [RENT_RENT_ROLL_SNAPSHOT_D, setRENT_RENT_ROLL_SNAPSHOT_D] = React.useState(null);



 
  useEffect(() => {
    document.title = "SRWAE | "+t('Rental Income Rent Roll Snapshot');  
	  
 
	if(location.hash=="#Return"){
		setNewData({ ...newData});
		setApp_Data({ ...newData})
		navigate('/RENT_Rent_Roll_Snapshot',{replace:true});
	}
	if(location.hash=="#New"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};

		const clientInfo = collectClientInfo();
		handleLoadNewRENT_RENT_ROLL_SNAPSHOT(clientInfo,"OpenNew");

		navigate('/RENT_Rent_Roll_Snapshot',{replace:true});
	}
	if(location.hash=="#Search"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/RENT_Rent_Roll_Snapshot_S',{replace:true});
	}
	if(location.hash=="#Update"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(RENT_RENT_ROLL_SNAPSHOT));
		if(Temp_Data2.status!="New"){
			Temp_Data2.status = "UpToDate";
			handlePutRENT_RENT_ROLL_SNAPSHOT(Temp_Data2);
		}else{
			Temp_Data2.status = "UpToDate";
			handlePostRENT_RENT_ROLL_SNAPSHOT(Temp_Data2);
			const collectClientInfo = () => {
			  return {
				userAgent: navigator.userAgent,
				language: navigator.language,
				platform: navigator.platform,
				screenResolution: `${screen.width}x${screen.height}`,
				colorDepth: screen.colorDepth,
				timezoneOffset: new Date().getTimezoneOffset(),
				timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
				cookieEnabled: navigator.cookieEnabled,
				javaEnabled: navigator.javaEnabled(),
				online: navigator.onLine,
				referrer: document.referrer,
				locationHref: window.location.href,
				screenOrientation: screen.orientation?.type || 'unknown'
			  };
			};

			const clientInfo = collectClientInfo();
			handleLoadNewRENT_RENT_ROLL_SNAPSHOT(clientInfo,"OpenNew");
		}
		navigate('/RENT_Rent_Roll_Snapshot',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/RENT_Rent_Roll_Snapshot_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/RENT_Rent_Roll_Snapshot_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/RENT_Rent_Roll_Snapshot_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(RENT_RENT_ROLL_SNAPSHOT));
		if(Temp_Data2.status!="New"){
			handleDeleteRENT_RENT_ROLL_SNAPSHOT(Temp_Data2);
			navigate('/RENT_Rent_Roll_Snapshot#New',{replace:true});
		} 
		else 
			navigate('/RENT_Rent_Roll_Snapshot',{replace:true});
	}
	if(location.hash=="#Export"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/RENT_Rent_Roll_Snapshot',{replace:true});
	}
	if(location.hash=="#Import"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/RENT_Rent_Roll_Snapshot',{replace:true});
	}
	if(location.hash=="#Help"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/RENT_Rent_Roll_Snapshot',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/RENT_Rent_Roll_Snapshot',{replace:true});
	}


  }, [location.hash]);   // Use cleanup for location.hash such as }, [location.hash]);



  useEffect(() => {
	  
	    if (!RENT_RENT_ROLL_SNAPSHOT) return;

    if (!initRef.current.headerHandled) {
	  for (let i = 1; i <= 10; i++) {
	  const sectionId = `#RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_${i}_SECTION`;
	  const headerId = `#RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [0];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
      initRef.current.headerHandled = true;
  }


  if (!initRef.current.dataTableHandled) {
    if ($('#Table2').length > 0) window.DataTableScript('#Table2');

    initRef.current.dataTableHandled = true;
  }  

  }, [RENT_RENT_ROLL_SNAPSHOT]) ;


  
  
  var Ids = [];
  for(var Ele in RENT_RENT_ROLL_SNAPSHOT){
	  for(var Sec in RENT_RENT_ROLL_SNAPSHOT[Ele]){
		if(Sec == "id")
			Ids.push(RENT_RENT_ROLL_SNAPSHOT[Ele]["id"]);
		else if(Sec == "status")
			Ids.push(RENT_RENT_ROLL_SNAPSHOT[Ele]["status"]);
		else if(Array.isArray(RENT_RENT_ROLL_SNAPSHOT[Ele][Sec]))
			  for(var Row in RENT_RENT_ROLL_SNAPSHOT[Ele][Sec])  // Convert to RENT_RENT_ROLL_SNAPSHOT[Ele][Sec].forEach((row) => { ... })
				for (var Id in Row) 
					Ids.push(Id);
		else
			for (var Id in RENT_RENT_ROLL_SNAPSHOT[Ele][Sec]) 
				Ids.push(Id);
	  }
  }
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
	if (didFetchRef.current) return;
    didFetchRef.current = true;

	var Temp_Data= JSON.parse(JSON.stringify(App_Data));
	Temp_Data["RENT_RENT_ROLL_SNAPSHOT"] = 0;
	setApp_Data({...Temp_Data})

	const collectClientInfo = () => {
	  return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown',
	  };
	};
	const baseClientInfo = collectClientInfo();
	handleLoadNewRENT_RENT_ROLL_SNAPSHOT(baseClientInfo,"FirstLoad");
 
/*	axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/RENT_RENT_ROLL_SNAPSHOT`).then((response1) => {
		if(!RENT_RENT_ROLL_SNAPSHOT) 
			setRENT_RENT_ROLL_SNAPSHOT(JSON.parse(JSON.stringify(response1.data)));
		axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/RENT_RENT_ROLL_SNAPSHOT_D`).then((response2) => {
			setRENT_RENT_ROLL_SNAPSHOT_D( JSON.parse(JSON.stringify(response2.data)));
			handleAddRENT_RENT_ROLL_SNAPSHOT_Load_Add_New(response1.data,response2.data);
		});
    });
*/

	//$('#navbarNav1').hide();
//$('#navbarNav6').hide();

  }, []);


 const handleLoadNewRENT_RENT_ROLL_SNAPSHOT = async (clientInfo, status) => {
	axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/RENT_RENT_ROLL_SNAPSHOT/New', {clientInfo, clientStamp: Date.now(), status:status})
	  .then(response => {
		setRENT_RENT_ROLL_SNAPSHOT(response.data);
	  })
	  .catch(error => {
		console.error('Error sending client info:', error);
	  });
  };



   

 const handleLastDataRENT_RENT_ROLL_SNAPSHOT = async (data) => {
	const collectClientInfo = () => {
	return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown'
	  };
	};
	
	const clientInfo = collectClientInfo();

    fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/RENT_RENT_ROLL_SNAPSHOT/Status', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ data: data, clientInfo:clientInfo , stamp: Date.now() })
    }).catch(err => {
      console.error("Error", err);
    });
  };


  const handlePutRENT_RENT_ROLL_SNAPSHOT = async (Updated) => {
    try {
		axios.put('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/RENT_RENT_ROLL_SNAPSHOT/', Updated);
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
  
  const handlePostRENT_RENT_ROLL_SNAPSHOT = async (Updated) => {
    try {
		axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/RENT_RENT_ROLL_SNAPSHOT', Updated);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
 
   
 

  const handleDeleteRENT_RENT_ROLL_SNAPSHOT = async (Updated) => {
    try {
		console.log(JSON.stringify(Updated));
		axios.delete('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/RENT_RENT_ROLL_SNAPSHOT', {
            data: Updated,
            headers: {
                'Content-Type': 'application/json' 
			    }
            });
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
     
const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_RENT_ROLL_SNAPSHOT));
	Temp_Data["1"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_1_0"]=value;
	//handleAddRENT_RENT_ROLL_SNAPSHOT(Temp_Data,App_Data['RENT_RENT_ROLL_SNAPSHOT']);
	Form_Data_onChange("1","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_1_0",value,Temp_Data);
 	//handleLastDataRENT_RENT_ROLL_SNAPSHOT(Temp_Data);
    setRENT_RENT_ROLL_SNAPSHOT(Temp_Data);
 }; 
  
    
const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_RENT_ROLL_SNAPSHOT));
	Temp_Data["1"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_1_1"]=value;
	//handleAddRENT_RENT_ROLL_SNAPSHOT(Temp_Data,App_Data['RENT_RENT_ROLL_SNAPSHOT']);
	Form_Data_onChange("1","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_1_1",value,Temp_Data);
 	//handleLastDataRENT_RENT_ROLL_SNAPSHOT(Temp_Data);
    setRENT_RENT_ROLL_SNAPSHOT(Temp_Data);
 }; 
  
    
const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_1_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_RENT_ROLL_SNAPSHOT));
	Temp_Data["1"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_1_2"]=value;
	//handleAddRENT_RENT_ROLL_SNAPSHOT(Temp_Data,App_Data['RENT_RENT_ROLL_SNAPSHOT']);
	Form_Data_onChange("1","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_1_2",value,Temp_Data);
 	//handleLastDataRENT_RENT_ROLL_SNAPSHOT(Temp_Data);
    setRENT_RENT_ROLL_SNAPSHOT(Temp_Data);
 }; 
  

const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_1_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_1_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_RENT_ROLL_SNAPSHOT));
	Temp_Data["1"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_1_3"]=value;
	Form_Data_onChange("1","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_1_3",value,Temp_Data);
 	//handleLastDataRENT_RENT_ROLL_SNAPSHOT(Temp_Data);
    setRENT_RENT_ROLL_SNAPSHOT(Temp_Data);
	//handleAddRENT_RENT_ROLL_SNAPSHOT(Temp_Data,App_Data['RENT_RENT_ROLL_SNAPSHOT']);
  }; 
  

    
const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_3_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_3_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_RENT_ROLL_SNAPSHOT));
	Temp_Data["3"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_3_0"]=value;
	//handleAddRENT_RENT_ROLL_SNAPSHOT(Temp_Data,App_Data['RENT_RENT_ROLL_SNAPSHOT']);
	Form_Data_onChange("3","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_3_0",value,Temp_Data);
 	//handleLastDataRENT_RENT_ROLL_SNAPSHOT(Temp_Data);
    setRENT_RENT_ROLL_SNAPSHOT(Temp_Data);
 }; 
  
    
const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_3_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_3_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_RENT_ROLL_SNAPSHOT));
	Temp_Data["3"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_3_1"]=value;
	//handleAddRENT_RENT_ROLL_SNAPSHOT(Temp_Data,App_Data['RENT_RENT_ROLL_SNAPSHOT']);
	Form_Data_onChange("3","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_3_1",value,Temp_Data);
 	//handleLastDataRENT_RENT_ROLL_SNAPSHOT(Temp_Data);
    setRENT_RENT_ROLL_SNAPSHOT(Temp_Data);
 }; 
  
    
const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_3_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_3_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_RENT_ROLL_SNAPSHOT));
	Temp_Data["3"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_3_2"]=value;
	//handleAddRENT_RENT_ROLL_SNAPSHOT(Temp_Data,App_Data['RENT_RENT_ROLL_SNAPSHOT']);
	Form_Data_onChange("3","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_3_2",value,Temp_Data);
 	//handleLastDataRENT_RENT_ROLL_SNAPSHOT(Temp_Data);
    setRENT_RENT_ROLL_SNAPSHOT(Temp_Data);
 }; 
  

const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_4_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_4_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_RENT_ROLL_SNAPSHOT));
	Temp_Data["4"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_4_0"]=value;
	Form_Data_onChange("4","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_4_0",value,Temp_Data);
 	//handleLastDataRENT_RENT_ROLL_SNAPSHOT(Temp_Data);
    setRENT_RENT_ROLL_SNAPSHOT(Temp_Data);
	//handleAddRENT_RENT_ROLL_SNAPSHOT(Temp_Data,App_Data['RENT_RENT_ROLL_SNAPSHOT']);
  }; 
  

    
const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_5_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_5_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_RENT_ROLL_SNAPSHOT));
	Temp_Data["5"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_5_0"]=value;
	//handleAddRENT_RENT_ROLL_SNAPSHOT(Temp_Data,App_Data['RENT_RENT_ROLL_SNAPSHOT']);
	Form_Data_onChange("5","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_5_0",value,Temp_Data);
 	//handleLastDataRENT_RENT_ROLL_SNAPSHOT(Temp_Data);
    setRENT_RENT_ROLL_SNAPSHOT(Temp_Data);
 }; 
  
    
const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_5_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_5_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_RENT_ROLL_SNAPSHOT));
	Temp_Data["5"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_5_1"]=value;
	//handleAddRENT_RENT_ROLL_SNAPSHOT(Temp_Data,App_Data['RENT_RENT_ROLL_SNAPSHOT']);
	Form_Data_onChange("5","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_5_1",value,Temp_Data);
 	//handleLastDataRENT_RENT_ROLL_SNAPSHOT(Temp_Data);
    setRENT_RENT_ROLL_SNAPSHOT(Temp_Data);
 }; 
  
    
const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_5_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_5_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_RENT_ROLL_SNAPSHOT));
	Temp_Data["5"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_5_2"]=value;
	//handleAddRENT_RENT_ROLL_SNAPSHOT(Temp_Data,App_Data['RENT_RENT_ROLL_SNAPSHOT']);
	Form_Data_onChange("5","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_5_2",value,Temp_Data);
 	//handleLastDataRENT_RENT_ROLL_SNAPSHOT(Temp_Data);
    setRENT_RENT_ROLL_SNAPSHOT(Temp_Data);
 }; 
  
    
const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_5_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_5_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_RENT_ROLL_SNAPSHOT));
	Temp_Data["5"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_5_3"]=value;
	//handleAddRENT_RENT_ROLL_SNAPSHOT(Temp_Data,App_Data['RENT_RENT_ROLL_SNAPSHOT']);
	Form_Data_onChange("5","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_5_3",value,Temp_Data);
 	//handleLastDataRENT_RENT_ROLL_SNAPSHOT(Temp_Data);
    setRENT_RENT_ROLL_SNAPSHOT(Temp_Data);
 }; 
  

const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_5_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_5_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_RENT_ROLL_SNAPSHOT));
	Temp_Data["5"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_5_4"]=value;
	Form_Data_onChange("5","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_5_4",value,Temp_Data);
 	//handleLastDataRENT_RENT_ROLL_SNAPSHOT(Temp_Data);
    setRENT_RENT_ROLL_SNAPSHOT(Temp_Data);
	//handleAddRENT_RENT_ROLL_SNAPSHOT(Temp_Data,App_Data['RENT_RENT_ROLL_SNAPSHOT']);
  }; 
  


const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_RENT_ROLL_SNAPSHOT));
	Temp_Data["9"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_9_0"]=value;
	Form_Data_onChange("9","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_9_0",value,Temp_Data);
 	//handleLastDataRENT_RENT_ROLL_SNAPSHOT(Temp_Data);
    setRENT_RENT_ROLL_SNAPSHOT(Temp_Data);
	//handleAddRENT_RENT_ROLL_SNAPSHOT(Temp_Data,App_Data['RENT_RENT_ROLL_SNAPSHOT']);
  }; 
  

    
const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_RENT_ROLL_SNAPSHOT));
	Temp_Data["9"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_9_1"]=value;
	//handleAddRENT_RENT_ROLL_SNAPSHOT(Temp_Data,App_Data['RENT_RENT_ROLL_SNAPSHOT']);
	Form_Data_onChange("9","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_9_1",value,Temp_Data);
 	//handleLastDataRENT_RENT_ROLL_SNAPSHOT(Temp_Data);
    setRENT_RENT_ROLL_SNAPSHOT(Temp_Data);
 }; 
  
    
const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_RENT_ROLL_SNAPSHOT));
	Temp_Data["9"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_9_2"]=value;
	//handleAddRENT_RENT_ROLL_SNAPSHOT(Temp_Data,App_Data['RENT_RENT_ROLL_SNAPSHOT']);
	Form_Data_onChange("9","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_9_2",value,Temp_Data);
 	//handleLastDataRENT_RENT_ROLL_SNAPSHOT(Temp_Data);
    setRENT_RENT_ROLL_SNAPSHOT(Temp_Data);
 }; 
  
    
const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_RENT_ROLL_SNAPSHOT));
	Temp_Data["9"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_9_3"]=value;
	//handleAddRENT_RENT_ROLL_SNAPSHOT(Temp_Data,App_Data['RENT_RENT_ROLL_SNAPSHOT']);
	Form_Data_onChange("9","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_9_3",value,Temp_Data);
 	//handleLastDataRENT_RENT_ROLL_SNAPSHOT(Temp_Data);
    setRENT_RENT_ROLL_SNAPSHOT(Temp_Data);
 }; 
  
    
const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_RENT_ROLL_SNAPSHOT));
	Temp_Data["9"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_9_4"]=value;
	//handleAddRENT_RENT_ROLL_SNAPSHOT(Temp_Data,App_Data['RENT_RENT_ROLL_SNAPSHOT']);
	Form_Data_onChange("9","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_9_4",value,Temp_Data);
 	//handleLastDataRENT_RENT_ROLL_SNAPSHOT(Temp_Data);
    setRENT_RENT_ROLL_SNAPSHOT(Temp_Data);
 }; 
  

const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_0_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_RENT_ROLL_SNAPSHOT));
	Temp_Data["2"][index]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_0"]=value;
    setRENT_RENT_ROLL_SNAPSHOT(Temp_Data);
	//handleAddRENT_RENT_ROLL_SNAPSHOT(Temp_Data,App_Data['RENT_RENT_ROLL_SNAPSHOT']);
  }; 
  

const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_1_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_RENT_ROLL_SNAPSHOT));
	Temp_Data["2"][index]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_1"]=value;
    setRENT_RENT_ROLL_SNAPSHOT(Temp_Data);
	//handleAddRENT_RENT_ROLL_SNAPSHOT(Temp_Data,App_Data['RENT_RENT_ROLL_SNAPSHOT']);
  }; 
  

const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_2_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_RENT_ROLL_SNAPSHOT));
	Temp_Data["2"][index]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_2"]=value;
    setRENT_RENT_ROLL_SNAPSHOT(Temp_Data);
	//handleAddRENT_RENT_ROLL_SNAPSHOT(Temp_Data,App_Data['RENT_RENT_ROLL_SNAPSHOT']);
  }; 
  

const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_3_Change = (event, index) => {
  const value = event.target.value;
  const Temp_Data = JSON.parse(JSON.stringify(RENT_RENT_ROLL_SNAPSHOT));  
  Temp_Data['2'][index]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_3"] = value;
  setRENT_RENT_ROLL_SNAPSHOT(Temp_Data);
};


const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_4_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_RENT_ROLL_SNAPSHOT));
	Temp_Data["2"][index]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_4"]=value;
    setRENT_RENT_ROLL_SNAPSHOT(Temp_Data);
	//handleAddRENT_RENT_ROLL_SNAPSHOT(Temp_Data,App_Data['RENT_RENT_ROLL_SNAPSHOT']);
  }; 
  

const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_5_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_5"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_RENT_ROLL_SNAPSHOT));
	Temp_Data["2"][index]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_5"]=value;
    setRENT_RENT_ROLL_SNAPSHOT(Temp_Data);
	//handleAddRENT_RENT_ROLL_SNAPSHOT(Temp_Data,App_Data['RENT_RENT_ROLL_SNAPSHOT']);
  }; 
  

const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_6_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_6"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_RENT_ROLL_SNAPSHOT));
	Temp_Data["2"][index]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_6"]=value;
    setRENT_RENT_ROLL_SNAPSHOT(Temp_Data);
	//handleAddRENT_RENT_ROLL_SNAPSHOT(Temp_Data,App_Data['RENT_RENT_ROLL_SNAPSHOT']);
  }; 
  

const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_7_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_7"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_RENT_ROLL_SNAPSHOT));
	Temp_Data["2"][index]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_7"]=value;
    setRENT_RENT_ROLL_SNAPSHOT(Temp_Data);
	//handleAddRENT_RENT_ROLL_SNAPSHOT(Temp_Data,App_Data['RENT_RENT_ROLL_SNAPSHOT']);
  }; 
  
  


const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_8_Change = (event,index) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_8"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_RENT_ROLL_SNAPSHOT));
	Temp_Data["2"][index]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_8"]=value ? true : false;
    setRENT_RENT_ROLL_SNAPSHOT(Temp_Data);
	//handleAddRENT_RENT_ROLL_SNAPSHOT(Temp_Data,App_Data['RENT_RENT_ROLL_SNAPSHOT']);
  }; 




 
const Form_Data_onChange = (Sec,ID,Value,Temp_Data) => {

};

  if (!RENT_RENT_ROLL_SNAPSHOT) return <div>Loading...</div>;;

   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
    //newData.Return_Data=selectedRowId;
	setNewData({ ...newData});
	setApp_Data(newData)
    window.location.hash = 'Return';
   };

const handleAddRow = (Sec) => {
  const newRow = {};
  switch(Sec) {
	  case('2'):
	    newRow['RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_0']='';
	    newRow['RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_1']='';
	    newRow['RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_2']='';
	    newRow['RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_3']='';
	    newRow['RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_4']='';
	    newRow['RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_5']='';
	    newRow['RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_6']='';
	    newRow['RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_7']='';
	    newRow['RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_8']='';
	    break;

  }


  const updatedRENT_RENT_ROLL_SNAPSHOT =JSON.parse(JSON.stringify(RENT_RENT_ROLL_SNAPSHOT));
  updatedRENT_RENT_ROLL_SNAPSHOT[Sec] = [...updatedRENT_RENT_ROLL_SNAPSHOT[Sec], newRow];
  setRENT_RENT_ROLL_SNAPSHOT(updatedRENT_RENT_ROLL_SNAPSHOT);
};

const handleDeleteRow = (sec,index) => {
  const updatedRENT_RENT_ROLL_SNAPSHOT = JSON.parse(JSON.stringify(RENT_RENT_ROLL_SNAPSHOT));
  updatedRENT_RENT_ROLL_SNAPSHOT[sec].splice(index, 1);
  setRENT_RENT_ROLL_SNAPSHOT(updatedRENT_RENT_ROLL_SNAPSHOT);
}; 

 const print_Canvas = async (ID) => {
const canvas = document.getElementById(ID);
const imgData = canvas.toDataURL("image/png");

const printWindow = window.open('', '_blank');
printWindow.document.write(`
  <html>
    <head><title>Print</title></head>
    <body style="margin:0">
      <img src="${imgData}" style="width:100%;"/>
      <script>
        window.onload = function() {
          window.print();
          window.onafterprint = function() {
            window.close();
          };
        };
      </script>
    </body>
  </html>
`);
printWindow.document.close();
}
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
  {t(`Rental Income Rent Roll Snapshot`)}
  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item active">
					  <a  id="navbarNav2" className="nav-link" href="#New">{t(`New`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav3" className="nav-link" href="#Search">{t(`Search`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav4" className="nav-link" href="#Update">{t(`Update`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav8" className="nav-link" href="#Delete">{t(`Delete`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>	
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Rental Income Rent Roll ID`)} <span className="toggle-icon">^</span></h2>
            <div id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`RENT Rent Roll ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_1_0" type="text" className="form-control" placeholder="RENT Rent Roll ID" value={RENT_RENT_ROLL_SNAPSHOT["1"][`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_1_0`]} 
						onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter RENT Rent Roll ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Asset ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_1_1" type="text" className="form-control" placeholder="Asset ID" value={RENT_RENT_ROLL_SNAPSHOT["1"][`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_1_1`]} 
						onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Asset ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '20ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Report Month`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_1_2" type="text" className="form-control" placeholder="Report Month" value={RENT_RENT_ROLL_SNAPSHOT["1"][`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_1_2`]} 
						onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_1_2_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_1_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '20ch' }}>
						 {t(`Enter Report Month`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Rent Roll Source`)}
					 </div>
                     <div className="card-body" >
                        <select id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_1_3"  value={RENT_RENT_ROLL_SNAPSHOT["1"][`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_1_3`]} onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_1_3_Change} className="form-control" name="Rent Roll Source"  >
						  <option value="Property Manager System">Property Manager System</option>
						  <option value="Bank Statement">Bank Statement</option>
						  <option value="Manual Upload">Manual Upload</option>
						  <option value="Accounting System">Accounting System</option>
						  <option value="Other">Other</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Rent Roll Source
				     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         <div className="container-fluid mt-5">
            <h2  id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_HEADER">{t(`Unit ID`)} <span className="toggle-icon">^</span></h2>
            <div  id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_SECTION"  className="table">
			                 {/* Table with Bootstrap Cards and DataTables */}
			   <button onClick={() => handleAddRow('2')}  style={{ display: 'none' }} className="btn btn-primary">
				  {t('Add Row')}
			   </button>
               <table id="Table2" className="table">
                  <thead>
                     <tr>
					                         <th>{t(`Unit ID`)}</th>
                        <th>{t(`Lease ID`)}</th>
                        <th>{t(`Tenant Name Masked`)}</th>
                        <th>{t(`Lease Status`)}</th>
                        <th>{t(`Contract Rent USD`)}</th>
                        <th>{t(`Market Rent USD`)}</th>
                        <th>{t(`Security Deposit Held USD`)}</th>
                        <th>{t(`Delinquent Amount USD`)}</th>
                        <th>{t(`Vacancy Flag`)}</th>

                     </tr>
                  </thead>
                  <tbody>
				    {RENT_RENT_ROLL_SNAPSHOT['2'].map((e, i) => {
                     return<tr  onClick={((e) => handleSingleClick(e,"TR"+e[`id`]))}  onDoubleClick={((e) => handleDoubleClick(e,"TR"+e[`id`]))} key={(e.id || i)} id={"TR"+(e.id || i)}>
                        <td  data-order={e[`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_0`]} data-search={e[`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_0`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_0" type="text" onChange={(ev) => RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_0_Change(ev, i)} className="form-control" value={e[`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_0`]} placeholder="Unit ID"/>
							  </div>
                           </div>
                        </td>
                        <td  data-order={e[`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_1`]} data-search={e[`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_1`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_1" type="text" onChange={(ev) => RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_1_Change(ev, i)} className="form-control" value={e[`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_1`]} placeholder="Lease ID"/>
							  </div>
                           </div>
                        </td>
                        <td  data-order={e[`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_2`]} data-search={e[`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_2`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_2" type="text" onChange={(ev) => RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_2_Change(ev, i)} className="form-control" value={e[`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_2`]} placeholder="Tenant Name Masked"/>
							  </div>
                           </div>
                        </td>
                        <td  data-order={e[`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_3`]} data-search={e[`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_3`]}>
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
                                 <select id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_3"  onChange={(ev) => RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_3_Change(ev, i)}  className="form-control" value={e[`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_3`]} name="Lease Status">
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Expired">Expired</option>
						  <option value="Terminated">Terminated</option>
						  <option value="Month-to-Month">Month-to-Month</option>
						  <option value="In Default">In Default</option>

                                 </select>
                              </div>
                           </div>
                        </td>
                        <td  data-order={e[`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_4`]} data-search={e[`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_4`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_4" type="text" onChange={(ev) => RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_4_Change(ev, i)} className="form-control" value={e[`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_4`]} placeholder="Contract Rent USD"/>
							  </div>
                           </div>
                        </td>
                        <td  data-order={e[`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_5`]} data-search={e[`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_5`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_5" type="text" onChange={(ev) => RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_5_Change(ev, i)} className="form-control" value={e[`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_5`]} placeholder="Market Rent USD"/>
							  </div>
                           </div>
                        </td>
                        <td  data-order={e[`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_6`]} data-search={e[`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_6`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_6" type="text" onChange={(ev) => RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_6_Change(ev, i)} className="form-control" value={e[`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_6`]} placeholder="Security Deposit Held USD"/>
							  </div>
                           </div>
                        </td>
                        <td  data-order={e[`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_7`]} data-search={e[`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_7`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_7" type="text" onChange={(ev) => RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_7_Change(ev, i)} className="form-control" value={e[`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_7`]} placeholder="Delinquent Amount USD"/>
							  </div>
                           </div>
                        </td>
                        <td>
						   <label style={{ display: 'inline-block', width: '100%', cursor: 'pointer' }}>
							  <input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_8"  type="checkbox" style={{ marginRight: '5px' }} onChange={(ev) => RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_8_Change(ev, i)} 
								  checked={e[`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_8`]  === true? e[`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_2_8`] : false  } />
						   </label>
						</td>

                     </tr>	
					})}
                  </tbody>
               </table>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_3_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Snapshot Total Units`)} <span className="toggle-icon">^</span></h2>
            <div id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_3_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Snapshot Total Units`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_3_0" type="text" className="form-control" placeholder="Snapshot Total Units" value={RENT_RENT_ROLL_SNAPSHOT["3"][`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_3_0`]} 
						onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_3_0_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_3_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Snapshot Total Units`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Snapshot Occupied Units`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_3_1" type="text" className="form-control" placeholder="Snapshot Occupied Units" value={RENT_RENT_ROLL_SNAPSHOT["3"][`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_3_1`]} 
						onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_3_1_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_3_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Snapshot Occupied Units`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Snapshot Gross Scheduled Rent USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_3_2" type="text" className="form-control" placeholder="Snapshot Gross Scheduled Rent USD" value={RENT_RENT_ROLL_SNAPSHOT["3"][`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_3_2`]} 
						onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_3_2_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_3_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Snapshot Gross Scheduled Rent USD`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_4_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Snapshot Status`)} <span className="toggle-icon">^</span></h2>
            <div id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_4_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Snapshot Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_4_0"  value={RENT_RENT_ROLL_SNAPSHOT["4"][`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_4_0`]} onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_4_0_Change} className="form-control" name="Snapshot Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Submitted">Submitted</option>
						  <option value="Under Review">Under Review</option>
						  <option value="Approved">Approved</option>
						  <option value="Rejected">Rejected</option>
						  <option value="Needs Revision">Needs Revision</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Snapshot Status
				     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_5_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Submitted By`)} <span className="toggle-icon">^</span></h2>
            <div id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_5_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Submitted By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_5_0" type="text" className="form-control" placeholder="Submitted By" value={RENT_RENT_ROLL_SNAPSHOT["5"][`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_5_0`]} 
						onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_5_0_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_5_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Submitted By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Submitted At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_5_1" type="text" className="form-control" placeholder="Submitted At" value={RENT_RENT_ROLL_SNAPSHOT["5"][`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_5_1`]} 
						onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_5_1_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_5_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Submitted At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Reviewed By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_5_2" type="text" className="form-control" placeholder="Reviewed By" value={RENT_RENT_ROLL_SNAPSHOT["5"][`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_5_2`]} 
						onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_5_2_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_5_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Reviewed By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Reviewed At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_5_3" type="text" className="form-control" placeholder="Reviewed At" value={RENT_RENT_ROLL_SNAPSHOT["5"][`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_5_3`]} 
						onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_5_3_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_5_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Reviewed At`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Approval Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_5_4"  value={RENT_RENT_ROLL_SNAPSHOT["5"][`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_5_4`]} onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_5_4_Change} className="form-control" name="Approval Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Submitted">Submitted</option>
						  <option value="Under Review">Under Review</option>
						  <option value="Revision Requested">Revision Requested</option>
						  <option value="Approved">Approved</option>
						  <option value="Rejected">Rejected</option>
						  <option value="Withdrawn">Withdrawn</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Approval Status
				     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_9_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Record Status`)} <span className="toggle-icon">^</span></h2>
            <div id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_9_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_9_0"  value={RENT_RENT_ROLL_SNAPSHOT["9"][`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_9_0`]} onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_9_1" type="text" className="form-control" placeholder="Created By" value={RENT_RENT_ROLL_SNAPSHOT["9"][`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_9_1`]} 
						onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_9_2" type="text" className="form-control" placeholder="Created At" value={RENT_RENT_ROLL_SNAPSHOT["9"][`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_9_2`]} 
						onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_9_3" type="text" className="form-control" placeholder="Updated By" value={RENT_RENT_ROLL_SNAPSHOT["9"][`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_9_3`]} 
						onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_9_4" type="text" className="form-control" placeholder="Updated At" value={RENT_RENT_ROLL_SNAPSHOT["9"][`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_9_4`]} 
						onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RENT_ROLL_SNAPSHOT_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>

  </>;
};

export default RENT_Rent_Roll_Snapshot;  